import { Box, Flex, Heading, Text } from "monday-ui-react-core";

import { BorderedBox, ShortLink } from "@/components/Common";

export function CliDownloadPanel() {
  return (
    <>
      <BorderedBox paddingX={Box.paddingXs.LARGE}>
        <Flex align={Flex.align.STRETCH} direction={Flex.directions.COLUMN} gap={Flex.gaps.XS}>
          <Heading
            type={Heading.types.h2}
            size={Heading.sizes.SMALL}
            style={{ padding: 0, marginTop: 0 }}
            value="Support & Resources"
          />
          <Text ellipsis={false} type={Text.types.TEXT2}>
            Learn how to <ShortLink path="monday_getstarted">get started</ShortLink> with CLI - Automate Actions.
          </Text>
          <Text ellipsis={false} type={Text.types.TEXT2}>
            Run commands from an external terminal with the <ShortLink path="acli-shell">ACLI Shell</ShortLink>!
            Download it <ShortLink path="acli-downloads">here</ShortLink>.
          </Text>
        </Flex>
      </BorderedBox>
    </>
  );
}
